import { Button } from "@/components/ui/button";

import { emailSupport } from "@/constants";

interface Props {
  uf?: string;
}

export const NotFound = ({ uf }: Props) => {
  return (
    <>
      <div className="flex flex-col gap-3 items-center justify-center">
        <h1 className="text-4xl font-bold text-center">Imóvel Indisponível</h1>
        <div className="flex flex-col items-center justify-center text-base text-muted-foreground w-4/6 space-y-14">
          <p className="text-center">
            Este imóvel não está mais disponível em nossa plataforma. Isso pode
            ocorrer pelos seguintes motivos:
          </p>
          <ul className="list-disc text-left pl-6">
            <li>O leilão já foi realizado</li>
            <li>O imóvel foi vendido ou retirado do leilão</li>
            <li>As informações do imóvel estão sendo atualizadas</li>
          </ul>
        </div>
      </div>
      {uf ? (
        <div className="flex items-center justify-center">
          <Button asChild size="lg">
            <a href={`/leilao-de-imoveis/${uf}`}>
              Ver mais leilão de imóveis em {uf.toUpperCase()}
            </a>
          </Button>
        </div>
      ) : null}
      <div className="flex items-center justify-center">
        <div>
          <Button asChild variant="outline">
            <a
              href={`mailto:${emailSupport}?subject=Pro Leilão - Dúvida imóvel não encontrado`}
              target="_blank"
              rel="nofollow"
            >
              Suporte via Email
            </a>
          </Button>
        </div>
      </div>
    </>
  );
};
